// 存档持久化接线（EP-002-S7）—— 订阅 store 变化，节流 200ms 写 localStorage。
// 仅当 `save` 引用真正改变时才排程写入（clock 等渲染用字段变化不触发写，符合 GDD 02 §④-4.3
// 「只在四个时机写」的精神：出发 / 掉落生成 / 结算 / 设置变更）。
import { useGameStore } from './index';
import { persist as writeSave } from '../save';
import type { StorageAdapter } from '../save/storage';
import type { SaveDataV1 } from '../save/types';

let adapter: StorageAdapter | null = null;
let timer: ReturnType<typeof setTimeout> | null = null;
let pending: SaveDataV1 | null = null;

// 设置当前使用的存储适配器（由 store.init 探测后注入）。
export function setAdapter(a: StorageAdapter): void {
  adapter = a;
}

// 立即写（init 首次落盘 / 重置用，不节流）。
export function persistNow(save: SaveDataV1): void {
  if (!adapter) return;
  if (timer) {
    clearTimeout(timer);
    timer = null;
  }
  writeSave(save, adapter);
  pending = null;
}

function flush(): void {
  if (adapter && pending) writeSave(pending, adapter);
  pending = null;
  timer = null;
}

// 订阅 store：save 变化时节流 200ms 写盘。立即写（清计时器）确保最新值不丢。
function schedulePersist(save: SaveDataV1): void {
  pending = save;
  if (timer) return;
  timer = setTimeout(() => {
    flush();
  }, 200);
}

// 暴露给 store.init 调用：建立订阅。
export function subscribeToStore(): void {
  useGameStore.subscribe((state, prev) => {
    if (state.save !== prev.save && state.save) {
      schedulePersist(state.save);
    }
  });
}
